export const TASK_COMPLETED = "task_completed";
export const LEVEL_COMPLETED = "level_completed";
export const USER_ACTION_COMPLETED = "user_action_completed";
export const LEVEL_START_OVER = "level_start_over";
export const ANCHOR_SELECTED = "anchor_selected";

export const LEVEL_ACTION_REQUIRED = "level_action_required";

export const RATING_CHANGED = "level_rating_changed";
export const BAD_RATING_CHANGED = "level_bad_rating_changed";

export const NEW_TERMINAL = "new_terminal";
export const RESET_VM = "reset_vm";
export const VM_RESET_DONE = "vm_reset_done";
